import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LoadingService } from 'src/app/loading.service';
import { BooksService } from '../books.service';
import { Testimonial } from '../testimonial';
import { TestimonialsService } from '../testimonials.service';
import { BOOK_CONSTANTS } from '../book.constants';
import { testimonialValidator } from '../testimonial-validation.directive';

@Component({
  selector: 'app-book-testimonials',
  templateUrl: './book-testimonials.component.html',
  styleUrls: ['./book-testimonials.component.css']
})
export class BookTestimonialsComponent implements OnChanges, OnDestroy {
  @Input() bookUid!: string

  strings = BOOK_CONSTANTS
  allTestimonials = this.testimonialsService.allTestimonials$

  constructor(
    private formBuilder: FormBuilder,
    public testimonialsService: TestimonialsService,
    public bookService: BooksService,
    private loadingService: LoadingService,
  ) { }

  newForm = this.formBuilder.group({
    reviewerName: [''],
    reviewerTitle: [''],
    quote: [''],
  }, { validators: testimonialValidator })

  editForm = this.formBuilder.group({
    reviewerName: [''],
    reviewerTitle: [''],
    quote: [''],
  }, { validators: testimonialValidator })

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bookUid'] && this.bookUid) {
      this.testimonialsService.addingNewTestimonial = false
      this.testimonialsService.editingTestimonialUid = undefined
      this.testimonialsService.watchTestimonials(this.bookUid)
    }
  }

  ngOnDestroy() {
    this.testimonialsService.stopWatching()
  }

  startAdd() {
    this.newForm.reset({ reviewerName: '', reviewerTitle: '', quote: '' })
    this.testimonialsService.addingNewTestimonial = true
    this.bookService.keepFocus = true
  }

  cancelAdd() {
    this.testimonialsService.addingNewTestimonial = false
    this.bookService.keepFocus = false
  }

  submitAdd() {
    const testimonial = {
      uid: undefined,
      bookUID: this.bookUid,
      reviewerName: this.newForm.value.reviewerName!!,
      reviewerTitle: this.newForm.value.reviewerTitle || undefined,
      quote: this.newForm.value.quote!!,
    } as Testimonial

    const loadingKey = `testimonial_add_${this.bookUid}_${Date.now()}`
    this.loadingService.addLoadingKey(loadingKey)
    this.testimonialsService.addNewTestimonial(this.bookUid, testimonial, loadingKey)
  }

  startEdit(testimonial: Testimonial) {
    this.editForm.reset({
      reviewerName: testimonial.reviewerName,
      reviewerTitle: testimonial.reviewerTitle || '',
      quote: testimonial.quote,
    })
    this.testimonialsService.editingTestimonialUid = testimonial.uid
    this.bookService.keepFocus = true
  }

  cancelEdit() {
    this.testimonialsService.editingTestimonialUid = undefined
    this.bookService.keepFocus = false
  }

  submitEdit(original: Testimonial) {
    const updated = {
      uid: original.uid,
      bookUID: this.bookUid,
      reviewerName: this.editForm.value.reviewerName!!,
      reviewerTitle: this.editForm.value.reviewerTitle || undefined,
      quote: this.editForm.value.quote!!,
    } as Testimonial

    if (JSON.stringify(updated) === JSON.stringify(original)) {
      this.cancelEdit()
      alert(this.strings.NO_CHANGES)
      return
    }

    this.testimonialsService.updateTestimonial(this.bookUid, updated)
  }

  removeTestimonial(testimonial: Testimonial) {
    this.testimonialsService.deleteTestimonial(this.bookUid, testimonial)
  }

  trackByUid(_index: number, testimonial: Testimonial): string {
    return testimonial.uid || ''
  }
}
